<mat-form-field [class]="this.size>0 ? 'sized' : ''">
  <mat-label>{{useLabelTranslation ? (label | translate) : label}}</mat-label>

  <mat-select [formControl]="$any(control.control)" (selectionChange)="onChange($event)" [multiple]="isMultiple">
    <mat-option *ngIf="withAllItem">{{ 'all' | translate }}</mat-option>
    <mat-option *ngIf="withNoneItem">{{ 'none' | translate }}</mat-option>
    <mat-option *ngFor="let item of itemList; let i = index" [value]="item.value"
      [disabled]="item.disabled">{{useLabelTranslation ? (item.display| translate) : item.display}}</mat-option>
  </mat-select>

  <mat-error *ngIf="this.control.form.errors">
    <app-error-message [errors]="this.control.form.errors"></app-error-message>
  </mat-error>
</mat-form-field>
